'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import IosFAQ from '@/components/faqs/ios-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import IosServies from '@/components/technologies/ios-demand';
import NativeIosDevelopment from '@/components/technologies/nativeIos-development';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Develop intuitive, engaging, and scalable mobile applications on the iOS platform for your enterprise, irrespective of complexity. We have experience in developing custom iOS apps across the entire Apple ecosystem."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'ios-hero'}
                bgPath={'hero-bg-grunge'}
            >
                iOS App <div>Development Company</div>
            </TechHeroApp>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="iOS" />
            <NativeIosDevelopment title="Make Your Business Stand Out With Fail-Proof Native iOS App Development"></NativeIosDevelopment>
            <IosServies />

            <HireProcess
                bg="bg-iosapp"
                pageTitle="Hire iOS App Developers To Create High-Performing Business Apps"
                desc="Get a free consultation, where we will go over your iOS app idea or current project in detail before providing our iOS application development services."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb for iOS Application Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best iOS Developers"
                desc="Select from different engagement models to hire iOS Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On iOS Development Services" bg="bg-iosapp">
                <IosFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
